const payWayAmountPieOptions = function payWayAmountPieOptions() {
  return {
    color: [],
    tooltip: {
      trigger: 'item',
      formatter: "{a} <br/>{b} : {c} ({d}%)",
    },
    legend: {
      show: false,
      orient: 'vertical',
      bottom: 'bottom',
      data: ['支付宝', '微信', '银联'],
      itemWidth: 10,
      itemHeight: 10,
      padding: [0, 10],
      itemGap: 50,
      icon: 'circle',
      textStyle: {
        color: '#333',
      },
    },
    series: [{
      name: '营业收入',
      type: 'pie',
      radius: ['50%', '70%'],
      center: ['50%', '60%'],
      data: [],
      itemStyle: {
        emphasis: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)',
        },
        normal: {
          label: {
            show: true,
            formatter: '{b} : ￥{c}',
            textStyle: { // 数值样式
              fontSize: 14,
            },
          },
          labelLine: { show: true },
        },
      },
    }],
  };
};

export default payWayAmountPieOptions;
